import { Col, Flex, Layout, Row, Space, Typography } from "antd";
import Footer from "../../components/v2/Footer/Footer";
import style from "./Error403.module.css";

const { Text, Paragraph } = Typography;

export default function Error403() {
  return (
    <>
      <Row style={{ minHeight: "calc(100vh - 32px)", width: "100%" }}>
        <Col xs={0} lg={9} className={style.Left}></Col>
        <Col xs={24} lg={15}>
          <Row justify="start" align="middle" style={{ height: "100%" }}>
            <Col xs={{ offset: 2, span: 20 }} lg={{ span: 18, offset: 4 }}>
              <Paragraph
                style={{
                  fontWeight: "bold",
                  fontSize: "80px",
                  color: "#E99E25",
                  lineHeight: 1,
                  marginBottom: "10px",
                }}
              >
                403
              </Paragraph>
              <Paragraph
                style={{
                  color: "#418CF0",
                  fontWeight: "500",
                  fontSize: "24px",
                  lineHeight: 1,
                  marginBottom: "4px",
                }}
              >
                Oops! You’ve hit a restricted area.
              </Paragraph>
              <Paragraph
                style={{
                  color: "#242424",
                  fontWeight: "bold",
                  fontSize: "35px",
                  lineHeight: 1,
                  marginBottom: "10px",
                }}
              >
                Access Denied!
              </Paragraph>
              <Paragraph
                style={{
                  color: "rgb(0 0 0 / 65%)",
                  fontSize: "16px",
                }}
              >
                Sorry, the Integrator ID and Token are invalid.
                <br />
                Please check your input or contact customer support.
              </Paragraph>
            </Col>
          </Row>
        </Col>
      </Row>
      <Footer style={{ width: "100%" }} />
    </>
  );
}
